import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import logo from '../images/logo.png';

import YearSelector from './YearSelector';

class Home extends Component {
  
  render() {
    return (
      <div>
        
        <HomeHeader />

        <div className="container">
            <main id="home-main">
                <div className="row">
                    <div className="col-md-6">
                        <YearSelector />
                    </div>

                    <div className="col-md-6">
                        <Link className="btn btn-lg" to='/musicVideos'>Take Me There!</Link>                    
                    </div>
                </div>
                <h4>Your Year. Your Song. Your Memories.</h4>
                <div className="fb-like" data-href="http://gnabagam.com/" data-layout="button" data-action="like" data-size="small" data-show-faces="true" data-share="true"></div>
            </main>
        </div>
      
      </div>
    );
  }
}

const HomeHeader = () => {
  return (
    <header>
      <figure>
          <img src={logo} className="img-responsive" alt="Gnabagam Logo" />
      </figure>
    </header>
  );  
}

const mapStateToProps = (state) => {
	return {
		year: state.year
	}
}

export default connect(mapStateToProps)(Home);


// WEBPACK FOOTER //
// ./src/components/Home.js